/**
 * [sc-48351 / task 48786] Le regole della griglia della pagina Ruoli, pure e
 * provabili senza montare la pagina.
 */
import { AZIONI, CASELLE, NOME_ADMIN } from "@/config/roles";

/** La casella ha una funzione dietro? Le altre si mostrano spente. */
export function casellaAttiva(area, azione) {
  return Boolean(CASELLE[area]?.includes(azione));
}

/**
 * La griglia dopo un clic. Un'azione accende Vedere; togliere Vedere spegne
 * l'area intera: non si modifica quello che non si vede. Stessa regola di
 * `normalizzaPermessi` nell'API.
 */
export function spunta(grid, area, azione, acceso) {
  const prima = new Set(grid[area] ?? []);
  if (acceso) {
    prima.add(azione);
    prima.add("V");
  } else if (azione === "V") {
    prima.clear();
  } else {
    prima.delete(azione);
  }
  const resto = { ...grid };
  delete resto[area];
  if (prima.size === 0) return resto;
  return { ...resto, [area]: AZIONI.filter((a) => prima.has(a)) };
}

/** Il valore della tendina del ruolo in Account. */
export const VALORE_AMMINISTRATORE = "admin";

export function valoreRuolo(operatore) {
  if (operatore?.isAdmin) return VALORE_AMMINISTRATORE;
  return operatore?.roleId ? String(operatore.roleId) : "";
}

/** Il corpo di `PATCH /auth/operators/:id/role` per la voce scelta. */
export function corpoRuolo(valore) {
  if (valore === VALORE_AMMINISTRATORE) return { isAdmin: true };
  return { roleId: Number(valore) };
}

/**
 * L'ultimo amministratore non si declassa (l'API risponde LAST_ADMIN): la
 * tendina non si apre, e il titolo dice perché.
 */
export function unicoAmministratore(operatore, operatori) {
  return (
    Boolean(operatore?.isAdmin) &&
    (operatori || []).filter((o) => o.isAdmin).length === 1
  );
}

/**
 * I magazzinieri che la modale DDT di PLUS propone: gli operatori il cui ruolo
 * ha l'area Magazzino. «Non amministratore» non basta più: vuol dire anche
 * commerciali, amministrazione, marketing.
 */
export function magazzinieri(operatori) {
  return (operatori || []).filter(
    (op) =>
      op.isAdmin === false &&
      Boolean(op.role?.permissions?.magazzino?.includes("V"))
  );
}

/**
 * Gli operatori che la modale DDT propone come «Operatore»: chi i DDT li può
 * emettere, cioè gli amministratori e chi ha «DDT Creare» nel ruolo.
 */
export function emettitoriDdt(operatori) {
  return (operatori || []).filter(
    (op) =>
      op.isAdmin === true || Boolean(op.role?.permissions?.ddt?.includes("C"))
  );
}

/**
 * Come si chiama il ruolo di un operatore nella console di piattaforma:
 * «Admin», il nome del ruolo, o «operatore» se non ne ha (START).
 */
export function etichettaRuolo(operatore) {
  if (operatore?.isAdmin) return NOME_ADMIN;
  return operatore?.role || "operatore";
}
